import { delay } from 'redux-saga'
import { take, put, call, fork, cancel, select  } from 'redux-saga/effects'
import * as types from '../constants/ActionTypes';
import {checkIfPaused, getGameSpeed, getCurrentEvent, lookingForGameScenes, playScenes, playEventSounds} from './common'
import { getInterval } from '../components/Pitch/gameJson'
import sliceGameOnEpisods from '../episods/episodSlicer'

export default function* summary () {
    console.log('summary saga started');
    
    let paused = yield select(checkIfPaused);
    if(paused)
        yield take(types.START_GAME);

    let episods = sliceGameOnEpisods()

    for(let i = 0; i < episods.length; i++) {
        yield* moveToSpecFrame(episods[i][0])
        const episodloop = yield fork(showEpisod, episods[i][0], episods[i][1])
        var action = yield take([types.MOVE_TO_NEXT_EPISOD, types.MOVE_TO_PREV_EPISOD]);
        yield cancel(episodloop)

        if(action.type === types.MOVE_TO_PREV_EPISOD) {
            i = Math.max(0, i - 2);
        }
    }
}

function* showEpisod(from, to) {
    let currentFrame = yield select(getCurrentEvent)
    
    while(currentFrame >= from && currentFrame < to) {
        let paused = yield select(checkIfPaused);
        if(paused)
            yield take(types.START_GAME);
        
        currentFrame = yield select(getCurrentEvent)
        let gameSpeed = yield select(getGameSpeed)
        let time = getInterval(currentFrame)
        yield put({ type: types.MOVE_TO_NEXT_EVENT })
        yield call(delay, gameSpeed * time)

        let nextFrame = window.Json.game[currentFrame];
        playEventSounds(nextFrame);
        let scenes = lookingForGameScenes(nextFrame)
        if(scenes != null)
            yield* playScenes(scenes)
    }

    yield put({ type: types.MOVE_TO_NEXT_EPISOD })
}

function* moveToSpecFrame(frameNum) {
    let currentFrame = yield select(getCurrentEvent)
    if(currentFrame !== frameNum)  {
        yield put({ type: types.MOVE_TO_EVENT, num: frameNum})
        let gameSpeed = yield select(getGameSpeed)
        yield call(delay, gameSpeed*30)
    }   
}



/** WEBPACK FOOTER **
 ** ./src/sagas/summary.js
 **/